import SlickSlider from "react-slick";
import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";

export const CardInfo = styled.div(({ theme }) => ({
  [theme.breakpoint.lg()]: {
    justifyContent: "start",
    width: "auto",
    height: "auto",
  },

  marginTop: "32px",
  display: "flex",
  justifyContent: "center",
}));

export const Icon = styled.img(({ theme }) => ({
  zIndex: "1",
  margin: "auto 0",
  width: "45px",
  height: "45px",
  objectFit: "scale-down",
}));

export const CardTitle = styled(Text)(({ theme }) => ({
  [theme.breakpoint.lg()]: {
    fontSize: "28px",
  },

  fontSize: "24px",
  lineHeight: "150%",
  color: "white",
}));

export const CardContainer = styled.div(({ theme }) => ({
  paddingLeft: "16px",
  color: "white",
  borderLeft: "1px solid white",
  marginLeft: "16px",
}));

export const Description = styled(Text)(({ theme }) => ({
  [theme.breakpoint.lg()]: {
    fontSize: "16px",
  },

  lineHeight: "150%",
  fontSize: "14px",
  fontWeight: "500",
  color: "white",
}));

export const Slider = styled(SlickSlider)(({ theme, roundedDots }) => ({
  ".slick-dots": {
    width: "90%",
  },

  ".slick-dots li button:before": {
    opacity: "1",
    fontSize: "10px",
    color: roundedDots ? theme.color.highlight["04"] : theme.color.brandPrimary.dark,
  },

  ".slick-dots li.slick-active button:before": {
    opacity: "1",
    color: theme.color.neutral["08"],
  },
}));

export const ContentCard = styled.div(({ theme }) => ({
  padding: "auto",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const ContainerImage = styled.img(({ theme }) => ({
  objectFit: "scale-down",
  height: "auto",
  width: "100%",
}));

export const Paragraph = styled(Text)(({ theme }) => ({
  margin: "32px 0px 18px 0px",
  fontWeight: "500",
  lineHeight: "18px",
  color: "#FFF",
  fontSize: "12px",
}));
